import { z } from "zod";

import { apiRequest } from "./apiHelpers/apiRequest";
import { apiConf } from ".";

const replacementSchema = z.object({
    name: z.string(),
    position: z.string(),
    justification: z.string(),
});

const recruitmentSchema = z.object({
    name: z.string(),
    date: z.iso.datetime({ offset: true }).transform((val) => new Date(val)),
    position: z.string(),
});

const motiveSchema = z.strictObject({
    id: z.string(),
    reason: z.enum([
        "activityIncrease",
        "replacement",
        "waitingRecruitment",
        "temporaryContract",
        "seasonalActivity",
        "trainingAction",
    ]),
    justification: z.string().catch(""),
    replacements: z.array(replacementSchema).optional(),
    recruitments: z.array(recruitmentSchema).optional(),
    organisationId: z.string(),
});

const getCompanyMotivesResSchema = z
    .strictObject({
        motives: z.array(motiveSchema).catch([]),
    })
    .transform((val) => val.motives);

export async function getCompanyMotives(signal?: AbortSignal) {
    const url = `${apiConf.BACK_URL}/motives`;
    return apiRequest({
        url,
        responseSchema: getCompanyMotivesResSchema,
        fetchOptions: {
            signal,
        },
    });
}
